import React from 'react';
import { Helmet } from "react-helmet";

const RefundPolicy = () => {
  return (
    <>
      <Helmet>
        <title>Lackfertighaus - Professionelle Ausbauarbeiten</title>
        <meta name="description" content="Lackfertighaus - Professionelle Ausbauarbeiten und Finishing-Lösungen in Deutschland. Hochwertige Handwerkskunst für Ihr Zuhause." />
        <link rel="canonical" href="https://lackfertighaus.com/refund-policy/" />
      </Helmet>

      <div className="policy-page">
      <div className="policy-container">
        <h1>Widerrufs- und Rückerstattungsrichtlinie</h1>
        <p className="last-updated">Letzte Aktualisierung: {new Date().toLocaleDateString('de-DE')}</p>

        <section>
          <h2>1. Einleitung</h2>
          <p>
            Diese Widerrufs- und Rückerstattungsrichtlinie regelt die Bedingungen, unter denen 
            Auftraggeber von einem mit Lackfertighaus geschlossenen Vertrag zurücktreten können 
            und Anspruch auf Rückerstattung bereits geleisteter Zahlungen haben. Die Richtlinie 
            gilt für alle Dienstleistungen im Bereich professioneller Ausbauarbeiten und 
            Finishing-Lösungen.
          </p>
        </section>

        <section>
          <h2>2. Widerrufsrecht für Verbraucher</h2>
          
          <h3>2.1 Widerrufsbelehrung</h3>
          <div className="legal-notice">
            <h4>Widerrufsrecht</h4>
            <p>
              Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag 
              zu widerrufen. Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des Vertragsabschlusses.
            </p>
            <p>
              Um Ihr Widerrufsrecht auszuüben, müssen Sie uns:
            </p>
            <p>
              <strong>Lackfertighaus</strong><br />
              Deutschland<br />
              E-Mail: lackfertighaus@hotmail.com
            </p>
            <p>
              mittels einer eindeutigen Erklärung (z.B. ein mit der Post versandter Brief oder E-Mail) 
              über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren. Sie können dafür das 
              beigefügte Muster-Widerrufsformular verwenden, das jedoch nicht vorgeschrieben ist.
            </p>
            <p>
              Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung 
              des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.
            </p>
          </div>

          <h3>2.2 Folgen des Widerrufs</h3>
          <div className="legal-notice">
            <h4>Folgen des Widerrufs</h4>
            <p>
              Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen 
              erhalten haben, einschließlich der Lieferkosten (mit Ausnahme der zusätzlichen Kosten, 
              die sich daraus ergeben, dass Sie eine andere Art der Lieferung als die von uns angebotene, 
              günstigste Standardlieferung gewählt haben), unverzüglich und spätestens binnen vierzehn 
              Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf dieses Vertrags 
              bei uns eingegangen ist.
            </p>
            <p>
              Für diese Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der ursprünglichen 
              Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde ausdrücklich etwas anderes 
              vereinbart; in keinem Fall werden Ihnen wegen dieser Rückzahlung Entgelte berechnet.
            </p>
            <p>
              Haben Sie verlangt, dass die Dienstleistungen während der Widerrufsfrist beginnen sollen, 
              so haben Sie uns einen angemessenen Betrag zu zahlen, der dem Anteil der bis zu dem 
              Zeitpunkt, zu dem Sie uns von der Ausübung des Widerrufsrechts hinsichtlich dieses 
              Vertrags unterrichten, bereits erbrachten Dienstleistungen im Vergleich zum Gesamtumfang 
              der im Vertrag vorgesehenen Dienstleistungen entspricht.
            </p>
          </div>

          <h3>2.3 Erlöschen des Widerrufsrechts</h3>
          <p>
            Das Widerrufsrecht erlischt bei einem Vertrag zur Erbringung von Dienstleistungen, wenn:
          </p>
          <ul>
            <li>Wir die Dienstleistung vollständig erbracht haben</li>
            <li>Mit der Ausführung der Dienstleistung erst begonnen wurde, nachdem Sie dazu Ihre 
                ausdrückliche Zustimmung gegeben haben</li>
            <li>Sie Ihre Kenntnis davon bestätigt haben, dass Sie Ihr Widerrufsrecht bei vollständiger 
                Vertragserfüllung durch uns verlieren</li>
          </ul>
        </section>

        <section>
          <h2>3. Muster-Widerrufsformular</h2>
          <div className="form-template">
            <p>
              Wenn Sie den Vertrag widerrufen wollen, können Sie dieses Formular verwenden:
            </p>
            <div className="form-box">
              <p>An:</p>
              <p>
                <strong>Lackfertighaus</strong><br />
                Deutschland<br />
                E-Mail: lackfertighaus@hotmail.com
              </p>
              <p>
                Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Vertrag über die 
                Erbringung der folgenden Dienstleistung:
              </p>
              <p>_________________________________________________</p>
              <p>Bestellt am (*) / erhalten am (*):</p>
              <p>_________________________________________________</p>
              <p>Name des/der Verbraucher(s):</p>
              <p>_________________________________________________</p>
              <p>Anschrift des/der Verbraucher(s):</p>
              <p>_________________________________________________</p>
              <p>_________________________________________________</p>
              <p>Unterschrift des/der Verbraucher(s) (nur bei Mitteilung auf Papier):</p>
              <p>_________________________________________________</p>
              <p>Datum:</p>
              <p>_________________________________________________</p>
              <p className="footnote">(*) Unzutreffendes streichen</p>
            </div>
          </div>
        </section>

        <section>
          <h2>4. Stornierung vor Arbeitsbeginn</h2>
          
          <h3>4.1 Stornierung durch den Auftraggeber</h3>
          <p>
            Stornierungen sind grundsätzlich möglich, solange noch keine Arbeiten begonnen wurden. 
            Je nach Zeitpunkt der Stornierung gelten folgende Bedingungen:
          </p>
          <ul>
            <li><strong>Mehr als 14 Tage vor geplantem Arbeitsbeginn:</strong> Kostenfreie Stornierung, 
                vollständige Rückerstattung bereits geleisteter Zahlungen</li>
            <li><strong>7-14 Tage vor geplantem Arbeitsbeginn:</strong> Stornierungsgebühr von 25% 
                der Auftragssumme für Planungs- und Vorbereitungskosten</li>
            <li><strong>3-6 Tage vor geplantem Arbeitsbeginn:</strong> Stornierungsgebühr von 50% 
                der Auftragssumme</li>
            <li><strong>Weniger als 3 Tage vor geplantem Arbeitsbeginn:</strong> Stornierungsgebühr 
                von 75% der Auftragssumme</li>
          </ul>

          <h3>4.2 Stornierung durch Lackfertighaus</h3>
          <p>
            Müssen wir einen Auftrag stornieren (z.B. aufgrund unvorhergesehener Umstände, Krankheit, 
            höherer Gewalt), werden bereits geleistete Zahlungen vollständig und unverzüglich 
            zurückerstattet.
          </p>
        </section>

        <section>
          <h2>5. Rückerstattung bei begonnenen Arbeiten</h2>
          
          <h3>5.1 Kündigung nach Arbeitsbeginn</h3>
          <p>
            Nach Beginn der Arbeiten ist eine Kündigung nur noch aus wichtigem Grund möglich. 
            In diesem Fall erfolgt die Abrechnung nach tatsächlich erbrachten Leistungen:
          </p>
          <ul>
            <li>Bereits durchgeführte Arbeiten werden vollständig berechnet</li>
            <li>Beschaffte Materialien werden berechnet</li>
            <li>Entgangener Gewinn wird anteilig berechnet</li>
            <li>Überzahlte Beträge werden zurückerstattet</li>
          </ul>

          <h3>5.2 Wichtiger Grund</h3>
          <p>
            Ein wichtiger Grund liegt insbesondere vor bei:
          </p>
          <ul>
            <li>Wesentlichen Abweichungen von der vereinbarten Leistung</li>
            <li>Erheblichen Mängeln in der Ausführung</li>
            <li>Nichteinhaltung vereinbarter Termine ohne triftigen Grund</li>
            <li>Verletzung wesentlicher Vertragspflichten</li>
          </ul>
        </section>

        <section>
          <h2>6. Rückerstattung bei Mängeln</h2>
          
          <h3>6.1 Mängelbeseitigung</h3>
          <p>
            Bei Vorliegen von Mängeln haben wir zunächst das Recht zur Nachbesserung. 
            Eine Rückerstattung kommt erst in Betracht, wenn:
          </p>
          <ul>
            <li>Die Nachbesserung fehlgeschlagen ist (in der Regel nach zwei Versuchen)</li>
            <li>Die Nachbesserung unzumutbar ist</li>
            <li>Wir die Nachbesserung verweigern</li>
            <li>Die Nachbesserung nicht fristgerecht erfolgt</li>
          </ul>

          <h3>6.2 Minderung und Rücktritt</h3>
          <p>
            Nach fehlgeschlagener Nachbesserung kann der Auftraggeber:
          </p>
          <ul>
            <li><strong>Minderung:</strong> Anteilige Rückerstattung entsprechend der Wertminderung</li>
            <li><strong>Rücktritt:</strong> Vollständige Rückerstattung bei erheblichen Mängeln, 
                die die Nutzbarkeit wesentlich beeinträchtigen</li>
          </ul>
        </section>

        <section>
          <h2>7. Rückerstattungsverfahren</h2>
          
          <h3>7.1 Beantragung</h3>
          <p>
            Rückerstattungen sind schriftlich zu beantragen unter Angabe von:
          </p>
          <ul>
            <li>Auftragsnummer und Rechnungsnummer</li>
            <li>Grund der Rückerstattung</li>
            <li>Bankverbindung für die Rücküberweisung</li>
            <li>Relevante Belege und Nachweise</li>
          </ul>

          <h3>7.2 Bearbeitungszeit</h3>
          <p>
            Wir bearbeiten Rückerstattungsanträge innerhalb von 14 Werktagen nach Eingang. 
            Die tatsächliche Gutschrift auf Ihrem Konto erfolgt abhängig von Ihrer Bank 
            in der Regel innerhalb von 3-5 Werktagen nach unserer Überweisung.
          </p>

          <h3>7.3 Rückerstattungsmethode</h3>
          <p>
            Rückerstattungen erfolgen grundsätzlich auf dem gleichen Weg wie die ursprüngliche Zahlung:
          </p>
          <ul>
            <li>Banküberweisung zurück auf das Ursprungskonto</li>
            <li>Gutschrift bei Kreditkartenzahlung</li>
            <li>Alternative Methoden nach Vereinbarung</li>
          </ul>
        </section>

        <section>
          <h2>8. Ausnahmen von der Rückerstattung</h2>
          <p>
            Eine Rückerstattung ist in folgenden Fällen ausgeschlossen:
          </p>
          <ul>
            <li>Bei vertragsgemäß erbrachten und abgenommenen Leistungen</li>
            <li>Bei Mängeln, die auf unsachgemäße Nutzung durch den Auftraggeber zurückzuführen sind</li>
            <li>Bei Mängeln durch nachträgliche Eingriffe Dritter</li>
            <li>Bei normaler Abnutzung oder Verschleiß</li>
            <li>Bei Schäden durch höhere Gewalt nach Leistungserbringung</li>
            <li>Bei individuell angefertigten Sonderleistungen nach Kundenwunsch</li>
          </ul>
        </section>

        <section>
          <h2>9. Teilrückerstattungen</h2>
          <p>
            In bestimmten Fällen können Teilrückerstattungen gewährt werden:
          </p>
          <ul>
            <li><strong>Teilmängel:</strong> Anteilige Rückerstattung bei teilweise mangelhafter Leistung</li>
            <li><strong>Teilstornierung:</strong> Rückerstattung für nicht erbrachte Teilleistungen</li>
            <li><strong>Kulanzfälle:</strong> Individuelle Lösungen nach Einzelfallprüfung</li>
          </ul>
        </section>

        <section>
          <h2>10. Gewährleistung und Garantie</h2>
          
          <h3>10.1 Gesetzliche Gewährleistung</h3>
          <p>
            Unabhängig von dieser Rückerstattungsrichtlinie gelten die gesetzlichen 
            Gewährleistungsrechte mit einer Frist von:
          </p>
          <ul>
            <li>2 Jahre für allgemeine Werkleistungen</li>
            <li>5 Jahre für Bauwerke und damit verbundene Leistungen</li>
          </ul>

          <h3>10.2 Freiwillige Garantie</h3>
          <p>
            Für bestimmte Leistungen bieten wir freiwillige Garantien an, die über die 
            gesetzliche Gewährleistung hinausgehen. Diese werden im jeweiligen Angebot 
            gesondert ausgewiesen.
          </p>
        </section>

        <section>
          <h2>11. Anzahlungen und Abschlagszahlungen</h2>
          
          <h3>11.1 Anzahlungen</h3>
          <p>
            Geleistete Anzahlungen werden wie folgt behandelt:
          </p>
          <ul>
            <li>Bei Stornierung vor Arbeitsbeginn: Rückerstattung abzüglich Stornierungsgebühren</li>
            <li>Bei Arbeitsbeginn: Verrechnung mit erbrachten Leistungen</li>
            <li>Bei Vertragserfüllung: Verrechnung mit Gesamtsumme</li>
          </ul>

          <h3>11.2 Abschlagszahlungen</h3>
          <p>
            Abschlagszahlungen werden entsprechend des tatsächlichen Baufortschritts berechnet. 
            Überzahlungen werden nach Endabrechnung zurückerstattet.
          </p>
        </section>

        <section>
          <h2>12. Besondere Vereinbarungen</h2>
          
          <h3>12.1 Individuelle Vereinbarungen</h3>
          <p>
            Abweichende Vereinbarungen zur Rückerstattung können im Einzelfall schriftlich 
            getroffen werden. Diese haben Vorrang vor dieser allgemeinen Richtlinie.
          </p>

          <h3>12.2 Kulanzregelungen</h3>
          <p>
            In besonderen Härtefällen können wir von dieser Richtlinie abweichende 
            Kulanzlösungen anbieten. Ein Rechtsanspruch besteht hierauf nicht.
          </p>
        </section>

        <section>
          <h2>13. Dokumentation</h2>
          <p>
            Zur Nachvollziehbarkeit von Rückerstattungsansprüchen dokumentieren wir:
          </p>
          <ul>
            <li>Alle Zahlungseingänge mit Datum und Betrag</li>
            <li>Arbeitsbeginn und -fortschritt mit Fotos</li>
            <li>Materialbestellungen und -kosten</li>
            <li>Kommunikation mit dem Auftraggeber</li>
            <li>Mängelrügen und Nachbesserungen</li>
          </ul>
        </section>

        <section>
          <h2>14. Streitbeilegung</h2>
          
          <h3>14.1 Einvernehmliche Lösung</h3>
          <p>
            Wir streben in allen Fällen eine einvernehmliche Lösung an. Bei Meinungsverschiedenheiten 
            über Rückerstattungsansprüche bieten wir an:
          </p>
          <ul>
            <li>Persönliches Gespräch vor Ort</li>
            <li>Begutachtung durch unabhängigen Sachverständigen</li>
            <li>Mediation durch neutrale Dritte</li>
          </ul>

          <h3>14.2 Rechtliche Schritte</h3>
          <p>
            Sollte keine einvernehmliche Lösung gefunden werden, stehen Ihnen die gesetzlichen 
            Rechtsbehelfe offen. Für Verbraucher besteht zudem die Möglichkeit der Online-Streitbeilegung 
            über die EU-Plattform: https://ec.europa.eu/consumers/odr
          </p>
        </section>

        <section>
          <h2>15. Änderungen dieser Richtlinie</h2>
          <p>
            Wir behalten uns vor, diese Rückerstattungsrichtlinie bei Bedarf anzupassen. 
            Für bereits bestehende Verträge gelten die zum Zeitpunkt des Vertragsabschlusses 
            gültigen Bedingungen. Wesentliche Änderungen werden wir rechtzeitig kommunizieren.
          </p>
        </section>

        <section>
          <h2>16. Kontakt für Rückerstattungsanfragen</h2>
          <p>
            Für alle Fragen zu Rückerstattungen und zur Geltendmachung von Ansprüchen 
            kontaktieren Sie uns bitte:
          </p>
          <p>
            <strong>Lackfertighaus</strong><br />
            Deutschland<br />
            E-Mail: lackfertighaus@hotmail.com
          </p>
          <p>
            Wir sind bestrebt, alle Anfragen schnell und kundenorientiert zu bearbeiten.
          </p>
        </section>

        <section className="disclaimer">
          <h2>Hinweis</h2>
          <p>
            Diese Rückerstattungsrichtlinie ersetzt nicht Ihre gesetzlichen Rechte. 
            Als Verbraucher haben Sie stets die gesetzlich garantierten Rechte, unabhängig 
            von den hier dargelegten Bedingungen. Im Zweifelsfall gilt immer die für Sie 
            günstigere Regelung.
          </p>
        </section>
      </div>
    </div>
  
    </>);
};

export default RefundPolicy;